export default __webpack_public_path__ + "f5094a111d9e367131b5242fd21e836c.png";